export function isViralTemplateSubmitDisabled(args: {
  isFormValid: boolean;
  submitting: boolean;
  creditCost?: number;
}) {
  const { isFormValid, submitting, creditCost } = args;
  return !isFormValid || submitting || creditCost == null;
}
